import chroma from 'chroma-js';

const red = chroma('#F44336');
const pink = chroma('#E91E63');
const purple = chroma('#9C27B0');
const deepPurple = chroma('#673AB7');
const indigo = chroma('#3F51B5');
const blue = chroma('#2196F3');
const lightBlue = chroma('#03A9F4');
const cyan = chroma('#00BCD4');
const teal = chroma('#009688');
const green = chroma('#4CAF50');
const lightGreen = chroma('#8BC34A');
const lime = chroma('#CDDC39');
const yellow = chroma('#FFEB3B');
const amber = chroma('#FFC107');
const orange = chroma('#FF9800');
const deepOrange = chroma('#FF5722');
const brown = chroma('#795548');
const gray = chroma('#9E9E9E');
const blueGray = chroma('#607D8B');

export default {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  gray,
  blueGray,
};
